import Velocity from 'velocity-animate'

export default (ctx, inject) => {
  inject('velocity', Velocity)
}



// WEBPACK FOOTER //
// ./plugins/velocity.js